import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MiscellaneousService } from 'src/app/core/services/miscellaneous.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  environment = environment;
  guideFiles: any[] = [];
  loadingGuides = true;

  constructor(
    public miscellaneousService: MiscellaneousService
  ) { }

  ngOnInit(): void {
    this.miscellaneousService.getUserGuides().subscribe({
      next: (res: any) => {
        this.guideFiles = res.files || [];
        this.loadingGuides = false;
      },
      error: () => {
        this.loadingGuides = false;
      }
    });
  }

}
